<template>
  <router-view v-slot="{ Component }">
    <keep-alive :include="['MyEvents']">
      <component :is="Component" />
    </keep-alive>
  </router-view>
</template>

<style lang="less"></style>
